import React from 'react';
import { FaTimesCircle } from 'react-icons/fa';
import { parsePaymentReturn } from '../services/paymentReturn';

export default function PagamentoFalha({ onVoltar }) {
  const { status } = parsePaymentReturn();

  const mensagens = {
    rejected: 'O pagamento foi rejeitado. Verifique os dados do cartão e tente novamente.',
    cancelled: 'Você cancelou o pagamento.',
    error: 'Ocorreu um erro ao processar o pagamento.'
  };

  const mensagem = mensagens[status] || 'Não foi possível processar seu pagamento.';

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%)',
      padding: 20
    }}>
      <main role="alert" aria-live="assertive" style={{
        background: '#fff',
        borderRadius: 20,
        padding: 40,
        maxWidth: 500,
        textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }}>
        <FaTimesCircle aria-hidden="true" style={{ fontSize: 64, color: '#c62828' }} />
        
        <h1 style={{ marginTop: 20, color: '#333' }}>
          Pagamento não concluído
        </h1>
        
        <p style={{ color: '#666', fontSize: 16, marginTop: 16, lineHeight: 1.6 }}>
          {mensagem}
        </p>

        <div style={{
          background: '#fff3cd',
          border: '1px solid #ffc107',
          borderRadius: 8,
          padding: 16,
          marginTop: 24,
          textAlign: 'left'
        }}>
          <p style={{ margin: 0, fontSize: 14, color: '#856404' }}>
            <strong>Antes de tentar novamente:</strong>
          </p>
          <ul style={{ margin: '8px 0 0 0', paddingLeft: 20, fontSize: 14, color: '#856404' }}>
            <li>Verifique se há saldo suficiente</li>
            <li>Confirme os dados do cartão</li>
            <li>Use outro cartão, se necessário</li>
            <li>Entre em contato com seu banco</li>
          </ul>
        </div>

        <div style={{ display: 'flex', gap: 12, marginTop: 30 }}>
          <button
            onClick={() => onVoltar && onVoltar()}
            style={{
              flex: 1,
              background: '#667eea',
              color: '#fff',
              border: 'none',
              borderRadius: 10,
              padding: '12px 20px',
              fontSize: 16,
              fontWeight: 600,
              cursor: 'pointer'
            }}
          >
            Voltar aos planos e tentar novamente
          </button>
        </div>
      </main>
    </div>
  );
}
